import { render } from "./footer-contact.vue?vue&type=template&id=9d6c36a6&scoped=true"
import script from "./footer-contact.vue?vue&type=script&lang=js"
export * from "./footer-contact.vue?vue&type=script&lang=js"

import "./footer-contact.vue?vue&type=style&index=0&id=9d6c36a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d6c36a6"]])

export default __exports__